<form [formGroup]="formGroup">
  <div class="d-flex flex-column">
    <div class="field-container">
      <h3> {{'createProposal.partnerInformationQuestion'|translate}}</h3>
    </div>

    <app-input-field [control]="formGroup.controls.name" class="field-container"
                     [label]="'createProposal.name'|translate"
                     [showInfo]="false"
                     [header]="'infoIcon.insurerName.header'|translate"
                     [mainContent]="'infoIcon.insurerName.content'|translate"
                     [isAbove]="false"
                     [isCentered]="true">
      <textarea name="name"
                cdkTextareaAutosize
                [cdkAutosizeMinRows]="3"
                formControlName="name" class="input input-text-area"> </textarea>
    </app-input-field>
    <div class="d-flex justify-content-between field-container">
      <app-input-field [control]="formGroup.controls.street" class="bigger-input"
                       [label]="'createProposal.street'|translate">
        <input name="street" formControlName="street"
               class="input">
      </app-input-field>

      <app-input-field [control]="formGroup.controls.houseNumber" class="smaller-input"
                       [label]="'createProposal.streetNumber'|translate">
        <input name="houseNumber" formControlName="houseNumber"
               class="input">
      </app-input-field>
    </div>

    <div class="d-flex justify-content-between field-container">
      <app-input-field [control]="formGroup.controls.postalCode" class="smaller-input"
                       [label]="'createProposal.postalCode'|translate">
        <input name="postalCode" formControlName="postalCode" type="text"
               class="input">
      </app-input-field>

      <app-input-field [control]="formGroup.controls.location" class="bigger-input"
                       [label]="'createProposal.location'|translate">
        <input name="location" formControlName="location"

               class="input">
      </app-input-field>
    </div>

    <div class="d-flex justify-content-between field-container">
      <app-input-field [control]="formGroup.controls.countryCode" class="smaller-input"
                       [label]="'createProposal.countryCode'|translate">
        <mat-select formControlName="countryCode"
                    class="input"
                    [value]="formGroup.value.countryCode" #singleSelect>
          <mat-option>
            <ngx-mat-select-search [formControl]="filterCtrlCountryCode" ngDefaultControl></ngx-mat-select-search>
          </mat-option>
          <mat-option>{{'createProposal.emptyOption'|translate}}</mat-option>
          <mat-option *ngFor="let option of filteredOptionsCountryCode |async" [value]="option">
            {{option}}
          </mat-option>

        </mat-select>
      </app-input-field>

      <app-input-field [control]="formGroup.controls.countryCode" class="bigger-input"
                       [label]="'createProposal.country'|translate">
        <mat-select formControlName="countryCode"
                    class="input"
                    [value]="formGroup.value.countryCode" #singleSelect>
          <mat-option>
            <ngx-mat-select-search [formControl]="filterCtrlCountry" ngDefaultControl></ngx-mat-select-search>
          </mat-option>
          <mat-option>{{'createProposal.emptyOption'|translate}}</mat-option>
          <mat-option *ngFor="let option of filteredOptionsCountry |async" [value]="getCountryCodeFromCountry(option)">
            {{option}}
          </mat-option>

        </mat-select>
      </app-input-field>


    </div>

  </div>
</form>
